import type {
    default as ConditionalFormattingStore,
    ConditionalFormattingStoreMap,
} from './schema/ConditionalFormattingStore';
import { createStore } from 'owa-satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import { getIndexerValueForMailboxInfo } from 'owa-client-types';
import type {
    ConditionalFormattingModification,
    ConditionalFormattingRule,
} from './schema/ConditionalFormattingRule';
import { getItem, itemExists, type LocalStorageKeys } from 'owa-local-storage';
import { trace } from 'owa-trace';
import type { ConditionalFormattingScenario } from './schema/ConditionalFormattingScenarioType';
import { getConditionalFormattingLocalStorageKey } from '../utils/getConditionalFormattingScenarioSettingUtils';

const initialConditionalFormattingStoreMap: ConditionalFormattingStoreMap = {
    entries: new Map(),
};

const conditionalFormattingStoreMap = createStore<ConditionalFormattingStoreMap>(
    'sharedConditionalFormattingStore',
    initialConditionalFormattingStoreMap
);

//Initializes the store to get conditional formatting rules.
export function getConditionalFormattingStore(
    mailboxInfo: MailboxInfo,
    scenario: ConditionalFormattingScenario
): ConditionalFormattingStore {
    const key = getIndexerValueForMailboxInfo(mailboxInfo) + '_' + scenario;
    let store = conditionalFormattingStoreMap().entries.get(key);
    if (!store) {
        store = {
            conditionalFormattingRules: fetchRulesFromLocalStorage(mailboxInfo, scenario),
            rowToModificationsMap: new Map<string, ConditionalFormattingModification[]>(),
        };
        conditionalFormattingStoreMap().entries.set(key, store);
        const defaultStore = conditionalFormattingStoreMap().entries.get(key);
        return defaultStore ? defaultStore : store;
    }
    return store;
}

function fetchRulesFromLocalStorage(
    mailboxInfo: MailboxInfo,
    scenario: ConditionalFormattingScenario
): ConditionalFormattingRule[] {
    const localStorageKey: LocalStorageKeys = getConditionalFormattingLocalStorageKey(
        mailboxInfo,
        scenario
    );
    try {
        return itemExists(window, localStorageKey)
            ? JSON.parse(getItem(window, localStorageKey) as string).filter(
                  (conditionalFormattingRule: ConditionalFormattingRule) =>
                      conditionalFormattingRule
              )
            : [];
    } catch (e) {
        // Errors resulting from enabling useUnknownInCatchVariables
        // TS18046: 'e' is of type 'unknown'.
        // @ts-expect-error
        trace.warn(e.message + getItem(window, localStorageKey));
        return [];
    }
}
